/** @format */

export enum TimerManagerDispatchEventEnum {
    createdManager = 'MANAGER_DISPATCH_MANAGER_CREATED',
    createdTimer = 'MANAGER_DISPATCH_TIMER_CREATED',
    startedTimer = 'MANAGER_DISPATCH_TIMER_STARTED',
    stoppedTimer = 'MANAGER_DISPATCH_TIMER_STOPPED',
    removedTimer = 'MANAGER_DISPATCH_TIMER_REMOVED',
    stoppedTimersInNamespace = 'MANAGER_DISPATCH_TIMERS_NAMESPACE_STOPPED',
    removedTimersInNamespace = 'MANAGER_DISPATCH_TIMERS_NAMESPACE_REMOVED',
    stoppedTimersGlobally = 'MANAGER_DISPATCH_TIMERS_GLOBAL_STOPPED',
    removedTimersGlobally = 'MANAGER_DISPATCH_TIMERS_GLOBAL_REMOVED',
    timerExists = 'MANAGER_DISPATCH_TIMER_EXISTS',
    timerRunning = 'MANAGER_DISPATCH_TIMER_RUNNING',
    timerExistsAndRunning = 'MANAGER_DISPATCH_TIMER_EXISTS_RUNNING',
    timerIterationsReached = 'MANAGER_DISPATCH_PROPAGATE_TIMER_ITERATIONS_REACHED',
    accessedMethodOnTimer = 'MANAGER_DISPATCH_TIMER_ACCESSED_METHOD_RESPONSE',
    // countedTimersInNamespace = 'MANAGER_DISPATCH_TIMERS_NAMESPACE_COUNT',
    // countedTimersGlobally = 'MANAGER_DISPATCH_TIMERS_GLOBAL_COUNT',
}
